import CloseView from "./v-close-view";

var plugin = {
  install(Vue) {
    if (this.installed) {
      return;
    }

    this.installed = true;

    Vue.component("v-close-view", CloseView);
  }
};

export default plugin;